import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SiteNavItem from '../SiteNavItem';
import { useSiteNavContext } from '../SiteNavHeader/SiteNavToggle/SiteNavContext';
import { useMediaQueries } from '../../../hooks';
import './SitePrimaryNav.scss';

const SitePrimaryNav = props => {
  const { setSubMenuIndex } = useSiteNavContext();
  const [, setShowOverlay] = useState([false, null]);
  const desktop = useMediaQueries('desktop');

  let mouseEnterTimeout = null;
  let leaveTimeout = null;

  const handleMouseEnter = (index, columnLength) => {
    if (desktop) {
      mouseEnterTimeout = setTimeout(() => {
        setSubMenuIndex(index);
      }, 200);
      setShowOverlay([index, columnLength > 0]);
    }
  };

  const handleMouseLeave = () => {
    if (desktop) {
      clearTimeout(mouseEnterTimeout);
      clearTimeout(leaveTimeout);
      leaveTimeout = setTimeout(() => {
        setSubMenuIndex(false);
      }, 200);
    }
  };

  const handleMouseLeaveContainer = () => {
    if (desktop) {
      clearTimeout(mouseEnterTimeout);
      clearTimeout(leaveTimeout);
      setSubMenuIndex(false);
    }
  };

  return (
    <ul
      onMouseLeave={handleMouseLeaveContainer}
      className="SitePrimaryNav">
      {props.items?.map((navMenuItem, index) => (
        <SiteNavItem
          handleMouseEnter={handleMouseEnter}
          handleMouseLeave={handleMouseLeave}
          item={navMenuItem}
          key={index}
          idx={index}
        />
      ))}
    </ul>
  );
};

SitePrimaryNav.propTypes = {
  items: PropTypes.array,
};

export default SitePrimaryNav;
